// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

common.View.create('canvas.blocks.custom.quoteSlider.Block', {
    onDOMLoad() {
        this.initSwiper();
    },

    initSwiper() {
        const swiperInstance = new Swiper('.portfolioSwiper', {
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                320: {
                    slidesPerView: 1.1,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 1.5,
                    spaceBetween: 32,
                },
                1240: {
                    slidesPerView: 2.25,
                    spaceBetween: 32,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                slideChange: function() {
                    const nextButton = document.querySelector('.swiper-button-next');
                    if (nextButton) {
                        if (this.isEnd) {
                            nextButton.style.opacity = '0.3';
                            nextButton.style.pointerEvents = 'none';
                        } else {
                            nextButton.style.opacity = '1';
                            nextButton.style.pointerEvents = 'auto';
                        }
                    }
                },
                init: function() {
                    // Set initial state
                    const nextButton = document.querySelector('.swiper-button-next');
                    if (nextButton && this.isEnd) {
                        nextButton.style.opacity = '0.3';
                        nextButton.style.pointerEvents = 'none';
                    }
                }
            }
        });

        Alpine.store('portfolioSlider', {
            swiper: swiperInstance,
        });
    },
});
